var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"steps"},_vm._l((_vm.steps),function(step,index){return _c('a',{key:index,staticClass:"steps__item",class:{
      'steps__item--active': _vm.currentStep === step,
    },attrs:{"href":"#","data-test":"tab"},on:{"click":function($event){$event.preventDefault();return _vm.$emit('selectStep', step)}}},[_c('span',[_vm._v(_vm._s(_vm.$t(("c.signup.step_" + step))))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }